//待办提醒url隐射表
export const backlogurls = [
  //采购人
  process.env.API_HOST + 'carry-out-notice-acceptance/acceptance', //执行通知书受理
  //采购需求编制
  // process.env.API_HOST + 'gp-purchase-demand/save',
  // process.env.API_HOST + 'gp-purchase-demand/delete' ,
  process.env.API_HOST + 'gp-purchase-demand/saveDetail',
  process.env.API_HOST + 'purchase-demand-answer/initSave', //采购需求答疑
  process.env.API_HOST + 'gp-procrement-file-approval/approval', //采购文件确认
  //process.env.API_HOST + '',//质疑回复
  process.env.API_HOST + 'enpert-application/submitEnpertApplication', //专家抽取申请
  process.env.API_HOST + 'confirm-win-bidder/submit', //确定中标人
  process.env.API_HOST + 'contract-publicity/save', //合同公示
  process.env.API_HOST + 'implementation/initSave', //履约登记
  //项目负责人
  process.env.API_HOST + 'carry-out-notice-assign-confirm/submitAssignConfirm', //标前任务确认
  process.env.API_HOST + 'gp-purchase-demand-confirm/confirmDetial', //采购需求确认
  process.env.API_HOST + 'gp-purchase-demand-notice/submit', //采购需求公示编制
  process.env.API_HOST + 'gp-project/submit', //项目入场登记
  process.env.API_HOST + 'carry_inassign_confirm/submitAssignerConfirm', //标中任务确认
  process.env.API_HOST + 'project-filing/submitProjectFiling', //项目备案申请
  //供应商
  //process.env.API_HOST + '', //标书下载及报名
  process.env.API_HOST + 'purchase-demand-query/initSave', //采购需求询问
  //集采部领导
  // process.env.API_HOST + '', //执行通知书受理
  process.env.API_HOST + 'carry-out-notice-assign/submitAssigner', //标前任务分派
  process.env.API_HOST + 'gp-purchase-demand-notice-approval/approval', //采购需求公示核验
  process.env.API_HOST + 'gp-procrement-file-approval/approval', //采购文件核验
  process.env.API_HOST + 'modify-notice-approval/approval', //信息更正公告核验
  process.env.API_HOST + 'carry_inassign/submitAssigner', //标中任务分派
  process.env.API_HOST + 'change-judge-application-approve/approval', //变更评委申请核验
  process.env.API_HOST + 'gp-reaccreditation-apply-approval/approval', //复评申请核验
  process.env.API_HOST + 'win-bid-announcement-approve/approval', //中标结果公告核验
  process.env.API_HOST + 'evaluation-bid-result-approve/approval', //中标结果公告核验
  process.env.API_HOST + 'win-bid-notice-approve-modify/approval', //标后结果更正核验
  process.env.API_HOST + 'contract-publicity-verification/approve', //合同公示核验
  process.env.API_HOST + 'gp-nullifield-bid-approval/approval', //废标公告核验
  process.env.API_HOST + 'gp-project-stop-approval/approval', //项目异常处理核验
  process.env.API_HOST + 'gp-project-stop-approval/approval', //项目暂停恢复核验
  //项目恢复核验
  process.env.API_HOST + 'gp-project-pause-approval/approval',
  process.env.API_HOST + 'gp-project-resumed-approval/approval',

  //监管部门
  process.env.API_HOST + 'change-purchaser-mode-approve/approval', //变更采购方式核验
  // process.env.API_HOST + '', //项目备案审阅
  //process.env.API_HOST + '',  //项目归档查阅
  process.env.API_HOST + 'complaint-answer/initSave', //投诉处理

  process.env.API_HOST + 'project-filing/setUnreadReminder' //查看

]
//访问uri后刷新项目菜单驱动
export const driverurls = [
  process.env.API_HOST + 'venue-book/saveVenue', //预约场地
  process.env.API_HOST + 'open-bid-result/submit', //开标结果记录
  process.env.API_HOST + 'procrement-file-and-notice/onRelease', //采购公告及文件文件发布
  process.env.API_HOST + 'qualification-audit-record/submit', //资审结果登记
  process.env.API_HOST + 'evaluation-bid-result/submit', //评审结果记录
  process.env.API_HOST + 'bidPurchaseFiling/submitPurchaseFilingInfo', //采购公告及文件文件编制
]



// WEBPACK FOOTER //
// ./src/router/router-url.js